/* eslint-disable @typescript-eslint/dot-notation */
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { AlphanumericCellEditorInlineComponent } from './alphanumeric-cell-editor-inline/alphanumeric-cell-editor-inline.component';
import { AlphanumericCellEditorPopupComponent } from './alphanumeric-cell-editor-popup/alphanumeric-cell-editor-popup.component';

/**
 * Editor Custom AgGrid for Alphanumeric Input.
 * Params:
 * - notAdmissibleChars: (Optional) it allows to specify as array of char any not admissible chars.
 * - inlineEditor (Default true) it allows to specify the preference between online or popup editor version.
 * - required: (Optional) It allows to specify required validator.
 *  NOTE: when in the AgGrid is enabled the fullRow editing this input param is ignored and the editor will be inline
 */
export interface IAlphanumericCellEditorParams {
    notAdmissibleChars?: string[];
    inlineEditor?: boolean; // true di default;
    required?: boolean;
}
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-alphanumeric-cell-editor',
    templateUrl: './alphanumeric-cell-editor.component.html',
    styleUrls: ['./alphanumeric-cell-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AlphanumericCellEditorInlineComponent, AlphanumericCellEditorPopupComponent, ReactiveFormsModule],
})
export class AlphanumericCellEditorComponent implements ICellEditorAngularComp {
    readonly editInline = signal<boolean>(false);
    readonly notAdmissibleChars = signal<string[]>([]);
    readonly cellWidth = signal<string>('');
    readonly cellReady = signal<boolean>(false);
    readonly formControl: FormControl = new FormControl<string>('');

    //inlineEditor?: boolean;

    agInit(params: ICellEditorParams & IAlphanumericCellEditorParams): void {
        this.cellWidth.set(params.column.getActualWidth() + 'px');
        this.editInline.set(params.inlineEditor !== false);
        this.notAdmissibleChars.set(params.notAdmissibleChars ?? []);
        //this.inlineEditor = params.api.getEditingCells().length === 1 ? this.editInline : true;
        if (params.required) this.formControl.addValidators(Validators.required);
        this.formControl.setValue(params.value ?? null, { emitEvent: false });
        this.formControl.updateValueAndValidity({ emitEvent: false });
    }

    getValue(): string | null {
        return this.formControl.valid ? this.formControl.getRawValue() : null;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return !this.editInline();
    }

    afterGuiAttached(): void {
        this.cellReady.set(true);
    }
}
